import Banner from "./components/Banner";
import BusinessSummary from "./components/BusinessSummary";
import ContactUs from "./components/ContactUs";
import Parts from "./components/Parts";
import UpcomingEvent from "./components/UpcomingEvent";
import Reviews from "./components/Reviews";

function Home() {
  return (
    <main>
      <Banner />
      <Parts />
      <BusinessSummary />
      <Reviews />
      <UpcomingEvent />
      <ContactUs />
    </main>
  );
}

export default Home;
